import React from 'react';

const ProfileSelectionCard = ({ profile, onSelection, selectedComponents, footer }) => {
	const disabled = !onSelection;

	// Don't pass a handleSelect when the original onSelection is undefined. This triggers the input fields to be disabled.
	const handleSelect = !onSelection
		? null
		: (e) => {
				const isChecked = e.target.checked;
				const inputFieldId = Number(e.target.value);

				const isProfile = profile.inputFieldId === inputFieldId;
				const isAddOn = !isProfile && profile.addOns?.some((addOn) => addOn.inputFieldId === inputFieldId);

				let newSelections = [...selectedComponents];

				if (isChecked) {
					newSelections.push(inputFieldId);

					const childIds = profile.components?.map((component) => component.inputFieldId) || [];
					if (isProfile) {
						// If parent selected -> remove children
						newSelections = newSelections.filter((id) => !childIds.includes(id));
					} else if (!isAddOn) {
						// If all children selected -> add parent & remove children
						const allChildrenSelected = childIds.every((id) => newSelections.includes(id));
						if (allChildrenSelected) {
							newSelections = newSelections.filter((id) => !childIds.includes(id));
							newSelections.push(profile.inputFieldId);
						}
					}

					onSelection(newSelections);
				} else {
					newSelections = newSelections.filter((id) => id !== inputFieldId);

					if (!isProfile && !isAddOn) {
						// If profile was previously selected -> add all siblings
						const siblingIds =
							profile.components
								?.map((component) => component.inputFieldId)
								.filter((id) => id !== inputFieldId) || [];
						const profileSelected = newSelections.some((id) => id === profile.inputFieldId);
						if (profileSelected) {
							newSelections = newSelections.filter((id) => id !== profile.inputFieldId);
							newSelections.push(...siblingIds);
						}
					}
					onSelection(newSelections);
				}
			};

	if (!profile) {
		return null;
	}

	const fullProfileSelected = selectedComponents?.some((id) => id === profile.inputFieldId);

	return (
		<div className="d-flex flex-column" style={{ marginTop: '2em' }}>
			{profile.header}
			<div className="card flex-grow-1">
				<div className="card-body">
					<div className="form-check">
						<input
							className="form-check-input"
							type="checkbox"
							id={`profile-${profile.inputFieldId}`}
							value={profile.inputFieldId}
							checked={fullProfileSelected}
							onChange={handleSelect}
							disabled={disabled}
						/>
						<label
							className="form-check-label text-reset fw-normal ps-2"
							htmlFor={`profile-${profile.inputFieldId}`}
						>
							{profile.label}
						</label>
					</div>

					<ComponentSelections
						components={profile.components}
						selectedComponents={selectedComponents}
						selectedByParent={fullProfileSelected}
						handleSelect={handleSelect}
					/>
					{profile.addOns?.length > 0 && (
						<>
							<hr className="my-2" />
							<p className="strong mb-2">Add-Ons</p>
							<ComponentSelections
								components={profile.addOns}
								selectedComponents={selectedComponents}
								handleSelect={handleSelect}
							/>
						</>
					)}
				</div>
				{footer && (
					<div
						className="card-footer flex-grow-1 align-content-end bg-transparent"
						style={{ borderTop: 'none' }}
					>
						{footer}
					</div>
				)}
			</div>
		</div>
	);
};

const ComponentSelections = ({ components, selectedComponents, selectedByParent, handleSelect }) => {
	const disabled = !handleSelect;
	if (!components?.length) {
		return null;
	}
	return (
		<ul style={{ listStyleType: 'none' }}>
			{components?.map((component) => {
				const selected = selectedComponents?.some((id) => id === component.inputFieldId);
				const inputId = `${component.inputFieldId}`;
				return (
					<li key={component.inputFieldId} className="">
						<div className="form-check">
							<input
								className="form-check-input"
								type="checkbox"
								value={component.inputFieldId}
								id={inputId}
								checked={selected || !!selectedByParent}
								onChange={handleSelect}
								disabled={disabled}
							/>
							<label className="form-check-label text-reset fw-normal ps-2" htmlFor={inputId}>
								{component.label}
							</label>
						</div>
					</li>
				);
			})}
		</ul>
	);
};

export default ProfileSelectionCard;
